/* eslint-disable jsx-a11y/anchor-is-valid */
// @flow
import React, { useState, useEffect } from 'react';
// components
import Table from '../../components/Table';
import { useTranslation } from 'react-i18next';
import { Loading } from 'react-loading-ui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { getAlertLive, getUserRequestAPI } from '../../API/RDPMS_API';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { getAlertLiveColumns, mapRequestDataToOptions, sizePerPageList } from './requestDataMapper';

import AlertFeedbackModal from '../../components/modal/AlertFeedbackModal';
import FaultySensorCell from '../../components/FaultySensorCell';
import { Row, Col, Modal } from 'react-bootstrap';

const AlertLive = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));
    const userRole = auth?.user?.role;

    const [notificationData, setNotificationData] = useState();
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(true);

    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const [predectiveCount, setPredectiveCount] = useState(0);
    const [failureCount, setFailureCount] = useState(0);
    const [totalsCount, setTotalsCount] = useState(0);

    const [selectedZones, setSelectedZones] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedDivisions, setSelectedDivisions] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedStation, setSelectedStation] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedAssetsType, setSelectedAssetsType] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);

    const [selectedAlertType, setSelectedAlertType] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);

    const [stations, setStations] = useState([]);
    const [zones, setZones] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [assetsTypeCode, setAssetsTypeCode] = useState([]);
    const [assetsType, setAssetsType] = useState([]);
    const [assetsNumber, setAssetsNumber] = useState([]);
    const [causesList, setCausesList] = useState([]);
    const [alertType, setAlertType] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
        {
            label: 'Failure',
            value: 'FAILURE',
        },
        {
            label: 'Success',
            value: 'SUCCESS',
        },
    ]);

    const [statusMessage, setStatusMessage] = useState('');
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        const fetchStation = async () => {
            await getRequestData(auth.user.id);
        };

        fetchStation();
    }, []);

    useEffect(() => {
        if (stations && stations.length > 0) {
            getAlertDetailsData(limit, pageNumber);
        }
    }, [stations]);

    const { t } = useTranslation();

    const handleFeedbackClick = (data) => {
        setShowFeedbackModal(true);
        setSelectedStatus(data.status);
        setNotificationData(data.notification);
    };

    const getAlertDetailsData = async (limits, pages) => {
        if (isFetching) return;
        setIsFetching(true);
        Loading();

        let limitNumber = limits ? limits : limit;
        let pagesNumber = pages ? pages : pageNumber;

        const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);
        const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

        let station = [];
        if (userRole === 'super admin') {
            station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
        } else {
            if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
                station = selectedStation.map((s) => s.value);
            } else {
                station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
            }
        }

        const assetsType = selectedAssetsType.some((a) => a.value === 'all')
            ? []
            : selectedAssetsType.map((a) => a.value);

        const alertType = selectedAlertType.some((a) => a.value === 'all') ? [] : selectedAlertType.map((a) => a.value);

        let request = {
            zone,
            division,
            station,
            asset_type: assetsType,
            alert_type: alertType,
            page_number: pagesNumber,
            page_size: limitNumber,
        };

        let response = await getAlertLive(request);

        if (response && response.isSuccess !== false) {
            let srNo = pagesNumber * limitNumber - limitNumber + 1;

            setPredectiveCount(response?.predictiveCount || 0);
            setFailureCount(response?.failureCount || 0);
            setTotalsCount(response?.totalCount || 0);

            const dataArray = (response?.tableRows || []).map((row) => ({
                srNo: srNo++,
                ...row,
            }));

            setPageNumber(response?.pagination?.currentPage || 1);
            setPageCount(response?.pagination?.totalPages || 1);
            setTotalCount(response?.pagination?.totalCount || 0);

            setData(dataArray);

            setStatusMessage(dataArray.length ? 'Alerts details fetched successfully' : 'No data found');
        } else {
            setData([]);
            setPredectiveCount(0);
            setFailureCount(0);
            setTotalsCount(0);
            setPageCount(1);
            setTotalCount(0);
            setStatusMessage('Data fetch failed, please try again');
        }
        Loading();
        setIsFetching(false);
    };

    const getRequestData = async (id) => {
        try {
            Loading(true);

            const response = await getUserRequestAPI(id);
            // console.log(response, 'getUserRequestAPI response....');

            if (response) {
                const { stations, zones, divisions, assetsTypeCode, assetsType, assetsNumber, causes } =
                    mapRequestDataToOptions(response);

                // Component state me directly set
                setStations(stations);
                setZones(zones);
                setDivisions(divisions);
                setAssetsTypeCode(assetsTypeCode);
                setAssetsType(assetsType);
                setAssetsNumber(assetsNumber);
                setCausesList(causes.filter((c) => c.value !== 'all'));
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            Loading(false);
        }
    };

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getAlertDetailsData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getAlertDetailsData(limit, value);
    };

    const feedbackCloseModalWithHeaderClass = () => {
        getAlertDetailsData(limit, pageNumber);
        setShowFeedbackModal(false);
    };

    const alertLiveColumns = getAlertLiveColumns({ userRole, handleFeedbackClick });

    return (
        <>
            <ToastContainer />

            <div className="py-1" style={{ width: '100%' }}>
                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        <div className="col-12 col-md-auto">
                            <h5
                                className="fw-bold mb-1"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    color: '#000',
                                    paddingLeft: '10px',
                                }}>
                                Alert Live
                            </h5>
                        </div>
                    </div>
                </div>

                <div
                    className="report-alert-card mb-2 p-1"
                    style={{
                        width: '100%',
                        boxShadow: '0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                        height: 'auto',
                    }}>
                    {/* sirf yaha change kiya hai */}
                    <div
                        className="container-fluid"
                        style={{
                            paddingLeft: '10px',
                            paddingRight: '10px',
                        }}>
                        <form>
                            <div className="row d-flex gx-2 gy-1 align-items-end">
                                <MultiSelectDropdown
                                    label="Zones"
                                    id="zoneSelect"
                                    options={zones}
                                    selectedValues={selectedZones}
                                    onChange={setSelectedZones}
                                />

                                <MultiSelectDropdown
                                    label="Divisions"
                                    id="divisionSelect"
                                    options={divisions}
                                    selectedValues={selectedDivisions}
                                    onChange={setSelectedDivisions}
                                />

                                <MultiSelectDropdown
                                    label="Station"
                                    id="stationSelect"
                                    options={stations}
                                    selectedValues={selectedStation}
                                    onChange={setSelectedStation}
                                />

                                <MultiSelectDropdown
                                    label="Assets Type"
                                    id="assetsSelect"
                                    options={assetsType}
                                    selectedValues={selectedAssetsType}
                                    onChange={setSelectedAssetsType}
                                />

                                <MultiSelectDropdown
                                    label="Alert Type"
                                    id="alertSelect"
                                    options={alertType}
                                    selectedValues={selectedAlertType}
                                    onChange={setSelectedAlertType}
                                />

                                <div className="col-auto ms-auto d-flex flex-column">
                                    <label style={{ visibility: 'hidden', marginBottom: '0.25rem' }}>Submit</label>
                                    <button
                                        type="button"
                                        className="btn"
                                        disabled={isFetching}
                                        onClick={() => getAlertDetailsData(5, 1)}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div
                    className="col-sm-12 card-alerts mt-2 mb-0 p-2 border-0 text-start no-radius"
                    style={{ width: '100%', position: 'relative' }}>
                    <div className="row mb-1">
                        <div className="col-12 d-flex justify-content-end gap-3 flex-wrap">
                            <div className="d-flex border px-3 py-2 align-items-center">
                                <strong className="me-2">Predictive</strong>
                                <span>{predectiveCount}</span>
                            </div>

                            <div className="d-flex border px-3 py-2 align-items-center">
                                <strong className="me-2">Failure</strong>
                                <span>{failureCount}</span>
                            </div>

                            <div className="d-flex border px-3 py-2 align-items-center">
                                <strong className="me-2">Total</strong>
                                <span>{totalsCount}</span>
                            </div>
                        </div>
                    </div>

                    <Table
                        columns={alertLiveColumns}
                        data={data}
                        pageSize={limit}
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        totalCount={totalCount}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        onPageChange={handlePageChange}
                        onPageClick={handlePageClick}
                    />

                    {data?.length === 0 && <div className="text-center py-4 text-muted">No records found</div>}
                </div>
            </div>

            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={showFeedbackModal}
                dialogClassName="modal-small-width"
                size="sm"
                onHide={feedbackCloseModalWithHeaderClass}>
                <Modal.Header closeButton className="modal-colored-header bg-primary">
                    <h4 className="modal-title text-light">
                        {t('Feedback')}{' '}
                        {notificationData?.device_name && notificationData?.name
                            ? `${notificationData.device_name} (${notificationData.name})`
                            : ''}
                    </h4>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <AlertFeedbackModal
                                status={selectedStatus}
                                archievesId={notificationData?.archive_id}
                                masterId={notificationData?.master_id}
                                stationId={notificationData?.station_id}
                                notificationId={notificationData?.id}
                                alertMaintenance={notificationData?.alert_maintenance}
                                notification={notificationData}
                                causes={causesList}
                                onHide={feedbackCloseModalWithHeaderClass}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer />
            </Modal>
        </>
    );
};

export default AlertLive;
